if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.cartUrl = this.dataset.cartUrl || '/cart';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('button--loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          this.cartDrawer.renderContents(parsedState);

          switch (submitButton.dataset.addToCartBehavior) {
            case 'open_cart_drawer':
              // Set timeout to force animation. Because content is just updated with renderContents
              setTimeout(() => {
                this.cartDrawer.open();
              });
              break;
            case 'show_cart_notification':
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState);
              break;
            case 'go_to_cart_page':
              this.cartUrl = this.getAttribute('this-cart-url') || '/cart';
              window.location.href = this.cartUrl;
              break;
            default:
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('button--loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}

if (!customElements.get('sticky-product-form')) {
  /**
   * Defines a custom element 'sticky-product-form' if not already defined.
   */
  customElements.define(
    'sticky-product-form',
    class StickyProductForm extends HTMLElement {
      /**
       * Constructor for StickyProductForm class.
       * Initializes references to several elements.
       */
      constructor() {
        super();
        this.productInfo = document.querySelector('[data-info-form]');
        this.productSelector = this.querySelector('[data-product-selector]');
        this.expandButton = this.querySelector('[data-variant-expand]');
        this.closeButton = this.querySelector('[data-variant-close]');
      }

      /**
       * Called when the element is added to the DOM.
       * Sets up IntersectionObserver and event listeners for expand and close buttons.
       */
      connectedCallback() {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            entry.isIntersecting ? this.toggleStickyForm(true) : this.toggleStickyForm(false);
          });
        });

        this.productInfo && this.observer.observe(this.productInfo);

        this.expandButton?.addEventListener('click', this.toggleProductSelector.bind(this));
        this.closeButton?.addEventListener('click', this.toggleProductSelector.bind(this));
      }

      /**
       * Toggles the sticky form visibility state
       * @param {boolean} hide - Whether to hide the form
       */
      toggleStickyForm(hide) {
        this.classList.toggle('translate-y-full', hide);
        document.body.classList.toggle('sticky-product-form', !hide);
      }

      /**
       * Called when the element is removed from the DOM.
       * Cleans up IntersectionObserver and event listeners.
       */
      disconnectedCallback() {
        this.productInfo && this.observer.disconnect();

        this.expandButton?.removeEventListener('click', this.toggleProductSelector.bind(this));
        this.closeButton?.removeEventListener('click', this.toggleProductSelector.bind(this));
        document.removeEventListener('click', this.closeDrawer.bind(this));
      }

      /**
       * Toggles the visibility of the product selector.
       * Adds or removes the 'expanded' class and sets up or removes a document click listener.
       */
      toggleProductSelector() {
        this.classList.toggle('expanded');

        this.classList.contains('expanded')
          ? document.addEventListener('click', this.closeDrawer.bind(this))
          : document.removeEventListener('click', this.closeDrawer.bind(this));
      }

      /**
       * Closes the product selector if a click event occurs outside the element.
       * @param {Event} event - The click event.
       */
      closeDrawer(event) {
        if (!this.contains(event.target)) {
          this.classList.remove('expanded');
          document.removeEventListener('click', this.closeDrawer.bind(this));
        }
      }
    }
  );
}
